import { render, staticRenderFns } from "./CreateOrderModal.vue?vue&type=template&id=532967d2"
import script from "./CreateOrderModal.vue?vue&type=script&lang=js"
export * from "./CreateOrderModal.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderModal.vue?vue&type=style&index=0&id=532967d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports